import styled from "styled-components";
import { Drawer } from "antd";

export const CloseTopDrawer = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
        justify-content: flex-end;
    }
`;


export const HeaderDrawer = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 15px;
    border-top: 2px solid var(--border-color);
    border-bottom: 2px solid var(--border-color);

    .HeaderDrawer__info {
        display: flex;
        flex-direction: column;
        gap: 3px;

        span {
            font-size: 11px;
            color: var(--text-color-light);
            font-weight: 600;
        }
    }
`;

export const DrawerCustomWrapper = styled(Drawer)`
    @media (max-width: 1024px) and (hover: none) {
        .ant-drawer-body {
            overflow: auto !important;
            -webkit-overflow-scrolling: touch;
        }
    }
`;

export const BodyDrawer = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    padding: 15px;

    @media (max-width: 1024px) and (hover: none) {
        flex: 1 1 auto;
        align-items: stretch;
        padding: 0;
    }
`;

export const FooterDrawer = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    gap: 10px;
    border-top: 2px solid var(--border-color);
    box-sizing: border-box;
    padding: 15px;
    box-shadow: 0px -5px 20px -19px rgb(0,0,0,0.5);
`;